import { render, staticRenderFns } from "./MagazzinoTipoDocumentoListComponent.vue?vue&type=template&id=294ae893"
import script from "./MagazzinoTipoDocumentoListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoTipoDocumentoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports